import styled from '@emotion/styled';

import UDInput from 'ud-form/components/input/component';
import { UDCreatableSelect, UDSelect } from 'ud-form/components/select/component';
import { theme } from 'styles/theme/theme';

export const BorderedSelect = styled(UDSelect)`
  border: 1px solid ${theme.colors.SurfaceCultured10};
  border-radius: 8px;
` as typeof UDSelect;

export const BorderedCreatableSelect = styled(UDCreatableSelect)`
  border: 1px solid ${theme.colors.SurfaceCultured10};
  border-radius: 8px;
` as typeof UDCreatableSelect;

export const PlayerNumberInput = styled(UDInput)`
  padding: 0 6px;
  height: 36px;
  text-align: center;
  max-width: 127px;
  min-width: 127px;
`;
